import './video-hero.scss';

import './import/landing-movie.mp4';
